import { createSlice } from "@reduxjs/toolkit";

export const firmSlice = createSlice({
  name: "firm",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
    firmlist: [],
    model: false,
    error_msg: null,
    rowdata: {},
    listCount: 0,
    firmParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    getFirm: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    firmListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.firmParams.page_size
      );

      return {
        ...state,
        listCount: action.payload.response.count,
        firmlist: action.payload.response.results,
        loading: false,
        firmParams: {
          ...state.firmParams,
          no_of_pages: noofpages,
        },
      };
    },
    firmAdd: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    firmAddSuccessful: (state, action) => {
      return {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {},
      };
    },
    firmEdit: (state, action) => {
      return {
        ...state,
        model: true,
        rowdata: action.payload,
      };
    },
    firmEditSuccessful: (state) => {
      return { ...state, loading: false, rowdata: {} };
    },
    firmDelete: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
        };
      }
    },
    SetFirmParams: (state, action) => {
      return {
        ...state,
        firmParams: action.payload,
      };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getFirm,
  firmListSuccessful,
  firmAdd,
  firmAddSuccessful,
  firmEdit,
  firmEditSuccessful,
  firmDelete,
  InputChangeValue,
  apiError,
  isModelVisible,
  SetFirmParams
} = firmSlice.actions;

export default firmSlice.reducer;
